'use client';

import { c as _c } from "react/compiler-runtime";
import { Form, FormProps, useFormMethods } from '@sola/ark-core/molecules/form/form.tsx';
export type PaymentMethodAddFormProps = {
  children?: React.ReactNode;
  onSubmit: FormProps['onSubmit'];
};
export const PaymentMethodAddForm: React.FC<PaymentMethodAddFormProps> = t0 => {
  const $ = _c(5);
  const {
    children,
    onSubmit
  } = t0;
  const formMethods = useFormMethods();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mode: "onTouched"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== formMethods || $[3] !== onSubmit) {
    t2 = <Form onSubmit={onSubmit} formMethods={formMethods} options={t1} isCustomError={true} noValidate={true}>{children}</Form>;
    $[1] = children;
    $[2] = formMethods;
    $[3] = onSubmit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};